import React from 'react';

import APIDocsBlock from '../APIDocsBlock';

const APIDocsAIBlock = () => {
  const helpURL = 'https://help.canny.io/en/articles/8202451-autopilot';
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Autopilot Feedback Processing</div>
        <div className="text">
          Autopilot is Canny's AI-powered set of tools that can detect, extract and deduplicate
          customer feedback. For Canny accounts with Autopilot, we offer direct access to Autopilot
          with an API that queues text input for processing.
          <br />
          <br />
          Each API request uses one Autopilot credit. <a href={helpURL}>Click here</a> to learn more
          about Autopilot and credits.
        </div>
      </div>
      <div></div>
    </APIDocsBlock>
  );
};

export default APIDocsAIBlock;
